package com.exura.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateListOf
import com.varabyte.kobweb.silk.style.CssStyleVariant

class DialogController {
    private val _stack = mutableStateListOf<@Composable () -> Unit>()
    private val _variantsStack = mutableStateListOf<CssStyleVariant<DialogPanelKind>?>()

    val stack: List<@Composable () -> Unit> get() = _stack
    val variants: List<CssStyleVariant<DialogPanelKind>?> get() = _variantsStack

    fun show(
        variant: CssStyleVariant<DialogPanelKind>? = null,
        content: @Composable () -> Unit,
    ) {
        _variantsStack.add(variant)
        _stack.add(content)
    }

    fun close() {
        if (_stack.isNotEmpty()) {
            _stack.removeLast()
            _variantsStack.removeLast()
        }
    }

    fun closeAll() {
        _stack.clear()
    }
}
